
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus, Minus, Calendar, DollarSign } from 'lucide-react';

const PatientCredits = () => {
  const creditHistory = [
    {
      id: '1',
      date: '2024-01-15',
      type: 'earned',
      amount: 125.00,
      description: 'Botox Treatment Purchase',
      balance: 275.50
    },
    {
      id: '2',
      date: '2024-01-10',
      type: 'spent',
      amount: 50.00,
      description: 'Dermaplaning Treatment',
      balance: 150.50
    },
    {
      id: '3',
      date: '2024-01-05',
      type: 'bonus',
      amount: 100.00,
      description: 'New Member Bonus',
      balance: 200.50
    },
    {
      id: '4',
      date: '2024-01-01',
      type: 'earned',
      amount: 100.50,
      description: 'Initial Purchase',
      balance: 100.50
    }
  ];

  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'earned':
      case 'bonus':
        return <Plus className="h-4 w-4 text-green-600" />;
      case 'spent':
        return <Minus className="h-4 w-4 text-red-600" />;
      default:
        return <DollarSign className="h-4 w-4 text-gray-600" />;
    }
  };

  const getTypeColor = (type: string) => {
    switch (type) {
      case 'earned': return 'bg-green-100 text-green-800';
      case 'spent': return 'bg-red-100 text-red-800';
      case 'bonus': return 'bg-purple-100 text-purple-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold font-juv-heading" style={{ color: '#5C322B' }}>
          Credit History
        </h2>
        <div className="flex space-x-2">
          <Button variant="outline">
            <Plus className="h-4 w-4 mr-2" />
            Add Credits
          </Button>
          <Button variant="outline">
            <Minus className="h-4 w-4 mr-2" />
            Adjust Credits
          </Button>
        </div>
      </div>

      {/* Current Balance Card */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <DollarSign className="h-5 w-5" style={{ color: '#A55C52' }} />
            <span>Current Balance</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-green-600">
            $275.50
          </div>
          <p className="text-sm text-gray-600 mt-1">
            Available for treatments and services
          </p>
        </CardContent>
      </Card>

      {/* Transaction History */}
      <Card>
        <CardHeader>
          <CardTitle>Transaction History</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {creditHistory.map((transaction) => (
              <div key={transaction.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center space-x-4">
                  {getTypeIcon(transaction.type)}
                  <div>
                    <p className="font-medium">{transaction.description}</p>
                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                      <Calendar className="h-3 w-3" />
                      <span>{new Date(transaction.date).toLocaleDateString()}</span>
                    </div>
                  </div>
                </div>
                
                <div className="text-right">
                  <div className="flex items-center space-x-2">
                    <Badge className={getTypeColor(transaction.type)}>
                      {transaction.type}
                    </Badge>
                    <span className={`font-semibold ${
                      transaction.type === 'spent' ? 'text-red-600' : 'text-green-600'
                    }`}>
                      {transaction.type === 'spent' ? '-' : '+'}${transaction.amount}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600">
                    Balance: ${transaction.balance}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PatientCredits;
